<template>
  <div class="ll-question-list">
    <p class="ll-question-list_title">
      {{ chapterCustomedIndex }}{{ title }}
    </p>
    <div class="ll-question-list_content">
      <div
        v-for="(list,listIndex) in questionList"
        :key="listIndex"
        class="ll-question-list_content-item"
      >
        <p
          v-if="list.title"
          class="ll-question-list_category-title ml-10"
        >
          {{ list.sectionCustomedIndex }}{{ list.title }}
        </p>
        <div class="ll-question-list_questions">
          <div
            v-for="(question,questionIndex) in list.questionList"
            :key="questionIndex"
            class="ll-question-list_question"
          >
            <ErrorChecklistQuestion
              v-if="!question.score && error"
              :error="error"
              :ques-num="question.questionCustomedIndex"
              :title="question.title"
              @error-click="$_onClick(question)"
            />
            <ChecklistQuestion
              v-else
              :ocap-content="ocapContent"
              :upload-url="uploadUrl"
              :editable="editable"
              :hide-focus="hideFocus"
              :hide-subtitle="hideSubtitle"
              :annex="hasAnnex"
              :ques-result="quesResult"
              :title="question.title"
              :subtitle="question.subtitle"
              :ques-type="question.quesType"
              :remark="question.remark"
              :images="question.images"
              :attaches="question.attaches"
              :ocap-remark="question.ocapRemark"
              :ocap-attaches="question.ocapAttaches"
              :articles="question.articles"
              :ques-num="question.questionCustomedIndex"
              :text-label="textLabel"
              :content-icon="contentIcon"
              :has-bottom-btn="hasBottomBtn"
              :focus="question.focus"
              :control-limit-data="question.controlLimitData"
              :spec-limit-data="question.specLimitData"
              :score="question.score"
              :alert-text="question.alertText"
              :risk-signal="question.riskSignal"
              :botton-btn-text="bottonBtnText"
              :remark-validate-rule="remarkValidateRule"
              :is-all-drop-down="isAllDropDown"
              @bottom-btn-click="$_bottomBtnClick(question)"
              @law-click="$_lawClick($event)"
              @editable-btn-submit="$_editableBtnSubmit($event,question)"
            />
          </div>
        </div>
      </div>
    </div>
    <LlActPopup
      v-if="lawPopupActive"
      :is-loading="lawContentLoading"
      :law-content="lawContent"
      :popup-active="lawPopupActive"
      @popup-close="$_lawPopupClose()"
    />
    <LlActPopup
      v-else
      :popup-active="lawPopupActive"
      @popup-close="$_lawPopupClose()"
    />
  </div>
</template>
<script>
export default {
  name: "LlQuestionList",

  props: {
    remarkValidateRule: {
      type: Boolean,
      default: false,
    },
    chapterCustomedIndex: {
      type: String,
      default: "",
    },
    ocapContent: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: String,
      default: "",
    },
    lawContentLoading: {
      type: Boolean,
      default: true,
    },
    lawContent: {
      type: Object,
      default() {
        return {};
      },
    },
    bottonBtnText: {
      type: String,
      default: "",
    },
    questionList: {
      type: Array,
      default() {
        return [];
      },
    },
    editable: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    categoryTitle: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    contentIcon: {
      type: String,
      default: "",
    },
    result: {
      type: Boolean,
      default: false,
    },
    quesResult: {
      type: Boolean,
      default: false,
    },
    hasAnnex: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: "",
    },
    errorIcon: {
      type: String,
      default: "",
    },
    hasBottomBtn: {
      type: Boolean,
      default: false,
    },
    hideFocus: {
      type: Boolean,
      default: false,
    },
    hideSubtitle: {
      type: Boolean,
      default: false,
    },
    isAllDropDown: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    lawPopupActive: false,
  }),

  methods: {
    $_editableBtnSubmit($event, question) {
      const editableContent = {};
      editableContent.images = $event.images;
      editableContent.remark = $event.remark;
      editableContent.questionId = question.id;
      this.$emit("editable-btn-submit", editableContent);
    },
    $_onClick(question) {
      this.$emit("error-click", question.id);
    },
    $_lawClick($event) {
      this.lawPopupActive = true;
      this.$emit("law-click", $event);
    },
    $_bottomBtnClick(question) {
      this.$emit("bottom-btn-click", question.id);
    },
    $_lawPopupClose() {
      this.lawPopupActive = false;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-question-list";
</style>